// extracted by mini-css-extract-plugin
export default {"cursorDot":"CustomCursor_cursorDot__CGJ01","cursorRing":"CustomCursor_cursorRing__9cFSP","cursorGlow":"CustomCursor_cursorGlow__Yu6Pt","activeGlow":"CustomCursor_activeGlow__40gM9"};